//CONFIG
export const UPDATE_AUTH_URL = "updateAuthUrl";
export const UPDATE_ADMIN_API_URL = "updateAdminApiUrl";
export const UPDATE_LOTTERY_API_URL = "updateLotteryApiUrl";
export const UPDATE_TELEGRAM_ADMIN_API_URL = "updateTelegramAdminApiUrl";

//LOADER
export const SET_LOADER = "setLoader";
